const modalTools = {
    createModal(name, objData) {
        $.post(requests.createModal, {
            lang: lang,
            name: name,
            page_title: document.title,
            href: window.location.href,
            data: objData,
        }).done((data) => {
            if (data.status === 'success') {
                if (name !== 'reviews') {
                    $('body').append(data.html);
                } else {
                    $('.js_append').append(data.html);
                }
                initValidate(`[data-modal="${name}"] .modal__form`);
                initPhoneMask();
                $(`[data-modal="${name}"][data-remove]`).show();
            } else {
                $('body').removeClass('hidden');
            }
        });
    }
};

$(document).ready(() => {
    $(document).on('click', '.js__create_modal', (e) => {
        e.preventDefault();
        const $btn = $(e.currentTarget);
        const modalName = $btn.attr('data-modal');

        if ($(`[data-modal="${modalName}"][data-remove]`).length === 0) {
            modalTools.createModal(modalName, { id: $btn.attr('data-id') });
        } else {
            $(`[data-modal="${modalName}"][data-remove]`).show();
        }

        if (modalName !== 'reviews') {
            $('body').addClass('hidden');
        }
    });

    $(document).on('click', '.js-close-modal, .modal-overlay', (e) => {
        const $modal = $(e.currentTarget).closest('.modal-wrap');
        const shouldRemove = $modal.attr('data-remove') === '1';

        if (shouldRemove) {
            $modal.remove();
        } else {
            $modal.hide();
        }
        $('body').removeClass('hidden');
    });
});